import { CallbackObject } from 'api/core/get-page-function';
import { GetPickedItemsVm } from './get-picked-items.vm';
import { plainToClass } from 'class-transformer';
import { instance } from 'api/core';
import { AxiosResponse } from 'axios';

export const getPickedItems = async (
    pickingId: string,
    offset: string,
    callback: CallbackObject<GetPickedItemsVm>
) => {
    const config: Record<string, any> = {
        headers: {
            'Content-Type': 'application/json',
        },
        params: {
            limit: 50,
            offset: offset,
        },
    };

    try {
        const res: AxiosResponse = await instance.get(`/picking/pickings/${pickingId}/picked`, config);
        callback.success(plainToClass(GetPickedItemsVm, res.data));
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};
